class StickyContainer extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = window.scrollY;
    this.threshold = 10; // Adjust sensitivity
    this.minScroll = 100; // Default minimum scroll before hiding
    this.container = null;
  }

  connectedCallback() {
    this.container = this.querySelector(".sticky-container");
    if (!this.container) return;

    this.container.classList.add("transition-transform", "duration-300");

    this.minScroll =
      parseInt(this.getAttribute("min-scroll"), 10) || this.minScroll;

    window.addEventListener("scroll", this.onScroll.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll.bind(this));
  }

  onScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY > this.minScroll) {
      if (currentScrollY > this.lastScrollY + this.threshold) {
        // Scrolling Down - Hide
        this.container.classList.add("-translate-y-full");
      }
    }
    if (currentScrollY < this.lastScrollY - this.threshold) {
      // Scrolling Up - Show
      this.container.classList.remove("-translate-y-full");
    }

    this.lastScrollY = currentScrollY;
  }
}

if (!customElements.get("sticky-container")) {
  customElements.define("sticky-container", StickyContainer);
}
